import React, { TableHTMLAttributes } from 'react';
import styles from './AGCollapsibleTable.module.css';

const AGCollapsibleTable: React.FC<TableHTMLAttributes<HTMLTableElement>> = ({ children }) => {
    return <table className={styles.agTable}>{children}</table>;
};

export default AGCollapsibleTable;
